<template>
  <div class="flex items-center justify-between mb-4">
    <h3 class="text-2xl font-semibold leading-6 text-gray-900">
      My Collections
    </h3>

    <RouterLink :to="{ name: 'collections.list' }" class="text-brand-dark underline underline-offset-2 hover:no-underline">
      Manage
    </RouterLink>
  </div>

  <ul class="space-y-3">
    <TransitionGroup name="list">
      <li
        v-for="collection in collectionStore.collections"
        :key="collection.id"
        class="flex items-center justify-between rounded-md px-6 py-4 shadow bg-white">
        <div>
          <h4 class="font-medium text-lg">
            {{ collection.name }}
          </h4>
        </div>
        <div class="flex justify-end space-x-4">
          <CollectionSummaryStat label="Locos" :value="collection.locomotiveCount" />
          <CollectionSummaryStat label="Cars" :value="collection.carCount" />
        </div>
      </li>
    </TransitionGroup>
  </ul>

  <!-- <p class="mt-4">

  </p> -->

</template>

<script lang="ts" setup>

import { useCollectionStore } from '@/stores';
import CollectionSummaryStat from './CollectionSummaryStat.vue';

const collectionStore = useCollectionStore();

</script>


<style scoped>
.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}
.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateY(-60px);
}
</style>
